import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  FormFieldSet,
  PageHeader,
  PageTitle,
  showToast,
} from "../../../../components";
import { addToDraft, getClientOneStart, updateClientStart } from "../../../../redux/slices/client/clientSlice";
import { useDispatch, useSelector } from "react-redux";
import { debounce } from "../../../../utils";

const AdditionalInformation = ({
  setActiveTab,
  isEditable,
  editClient = "",
  clientId = null,
}) => {
  const dispatch = useDispatch();
  const clientProfileUiid = useSelector((state) => state.client.clientProfileUiid);
  const clientDetails = useSelector(
    (state) => state.client.currentClient.clientDetails
  );
  const [text, setText] = useState("");

    useEffect(() => {
      if (clientProfileUiid) {
        dispatch(
          getClientOneStart({
            clientUiid: clientProfileUiid,
            retrieve: `additionalInfo`,
          })
        );
      }
    }, [clientProfileUiid]);
  
  
   useEffect(() => {
      // if (clientProfileUiid) {
      if (true) {
       
        setText(clientDetails?.additionalInfo || "");
      }
  //  }, [clientDetails]);
   }, []);
  
  const handleSave = () => {
          if (!clientProfileUiid) {
            showToast("Client's Business Information Not Saved", "error");
            return;
          }
          let prepareSubmissionData = {
            uiid: clientProfileUiid,
            coll: `Client`,
            payload: [
              {
                type: "SET",
                value: {
                  additionalInfo: text
                }
              }
            ],
          };
          dispatch(updateClientStart({ ...prepareSubmissionData }));
          setActiveTab((prev) => prev + 1);
  };
  const handleBack = () => {
    setTimeout(() => {
      // Move to back tab
      setActiveTab((prev) => prev - 1);
    }, 500);
  };
   const handleDraft = useMemo(
        () =>
          debounce((value) => {
            dispatch(
              // addToDraft({
              //   [field]: value ? value : "",
              // })
              addToDraft({...value})
            );
          }, 1000),
        [dispatch]
        );
        useEffect(() => {
          let clientData = {
            additionalInfo: text
          }
          handleDraft(clientData);
        }, [text]);
  return (
    <div>
      <div className="flex flex-col w-full h-full gap-8 px-8 py-3 overflow-auto rounded">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle
                title={"Additional Information"}
                icon={"badge"}
                tag="h5"
              />
            </div>
          }
          RightSection={
            <>
              {isEditable && editClient && (
                <>
                  {editClient !== "/client/client-details" && (
                    <Button
                      title="Back"
                      size="sm"
                      icon={"arrow_left_alt"}
                      onClick={handleBack}
                    />
                  )}

                  <Button title="Save" size="sm" onClick={handleSave} />
                </>
              )}
            </>
          }
        />
        <div className="max-w-[90%]">
          <FormFieldSet
            type={"textArea"}
            title={"Additional Info"}
            size="lg"
            rows={4}
            placeholder="Enter your text"
            onChange={setText}
            value={text}
            disabled={!isEditable}
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalInformation;
